import api from './client';

export interface ApiKey {
  id: number;
  name: string;
  key_prefix: string;
  scopes: string[];
  is_active: boolean;
  last_used_at: string | null;
  expires_at: string | null;
  created_at: string;
}

export interface ApiKeyCreated extends ApiKey {
  plaintext_key: string;
}

export interface ApiScope {
  value: string;
  label: string;
}

export const apiKeysApi = {
  list: () => api.get<{ data: ApiKey[] }>('/api-keys'),
  scopes: () => api.get<{ data: ApiScope[] }>('/api-keys/scopes'),
  create: (name: string, scopes: string[]) =>
    api.post<{ data: ApiKeyCreated }>('/api-keys', { name, scopes }),
  rotate: (id: number) =>
    api.post<{ data: ApiKeyCreated }>(`/api-keys/${id}/rotate`),
  revoke: (id: number) =>
    api.post<{ data: ApiKey }>(`/api-keys/${id}/revoke`),
  reactivate: (id: number) =>
    api.post<{ data: ApiKey }>(`/api-keys/${id}/reactivate`),
  delete: (id: number) =>
    api.delete<{ data: null }>(`/api-keys/${id}`),
};
